

































































import _ from 'lodash'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Getter, State, Action, Mutation } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import { Maybe } from '@/types/general'
import Search from '@/util/Search'
import Entry from '@/data/entry-model'

@Component({ name: 'v-vault-selector' })
export default class VVaultSelector extends Vue {
    editing: boolean = false

    stretchWidth: number = 100

    searchTerm: string = ''

    /**
     * Vault ID value
     */
    @Prop({ type: String, default: '' })
    value!: string

    /**
     * Vault ID value
     */
    @Prop({ type: Boolean, default: false })
    anchorRight!: boolean

    /**
     * Allow selection of root vault
     */
    @Prop({ type: Boolean, default: false })
    allowRoot!: boolean

    /**
     * Allow creation of new vaults
     */
    @Prop({ type: Boolean, default: false })
    allowCreate!: boolean

    /**
     * Whether to filter out the current open entry
     */
    @Prop({ type: Boolean, default: false })
    filterOpenEntry!: boolean

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    @Getter
    getEntry!: (entry: string | Entry) => Entry

    @Getter
    topLevelEntries!: Entry[]

    get vault(): Maybe<Entry> {
        if (!this.value) {
            return undefined
        }
        return this.getEntry(this.value)
    }

    get path(): string[] {
        if (!this.vault) {
            return ['root']
        }
        return this.vault.titlePath
    }

    get topVaults(): Entry[] {
        return this.topLevelEntries
            .filter(entry => entry.isVault())
            .filter(entry => !this.searchTerm || Search.score(this.searchTerm, entry))
            .filter(entry => !this.filterOpenEntry || (this.vault && entry.id !== this.vault.id))
    }

    updateSearchTerm(value: string): void {
        this.searchTerm = value
        this.$nextTick(() => {
            this.stretchWidth = (this.$refs.sizer as HTMLElement).clientWidth + 32
            if (this.stretchWidth < 100) {
                this.stretchWidth = 100
            }
        })
    }

    update(vaultId: string): void {
        this.$emit('input', vaultId)
        this.stopEditing()
    }

    startEditing(event: MouseEvent): void {
        this.editing = true
        this.searchTerm = ''
        this.$nextTick(() => {
            (this.$refs.input as HTMLElement).focus()
            window.addEventListener('click', this.stopEditing)
        })
        event.preventDefault()
        event.stopPropagation()
    }

    stopEditing(): void {
        this.editing = false
        this.searchTerm = ''
        window.removeEventListener('click', this.stopEditing)
    }
}
